// import React from 'react'
// import Intro from '../assets/intro.jpg'

// function intro() {
//     return (
//         <div>
//             <section id="intro" className='bg-light'style={{paddingBottom:'50px', paddingTop:'50px'}}>
//           <div class="container">
//             <div class="section-label" >The Nexora Advantage</div>
//         <h2 class="section-title2" >An AI focused investment and operating platform</h2>
//     <div class="row g-5 align-items-start align-items-center">
//       <div class="col-lg-5">
//         {/* <div class="section-label" >The Nexora Advantage</div>
//         <h2 class="section-title2" >An AI focused investment and operating platform</h2> */}
//         <div class="divider-gold"></div>
//         <p class="intro-body" style={{color:'white'}}>
//       Businesses have more data, software, and digital workflows than ever before. Yet much of that information remains fragmented across applications, spreadsheets, emails, and disconnected systems.

// Nexora Systems is building an AI-powered operations platform designed to bring those systems together.
//         </p>
//         <p class="intro-body" style={{marginTop:'16px', color:'white'}}>


// Our platform enables businesses to connect their existing software, automate repetitive processes, surface actionable insights, and deploy intelligent AI agents across critical business functions—all through a unified technology layer.

// Rather than asking businesses to replace the systems they already use, Nexora is designed to work alongside them.

// Our long-term vision is to become the intelligent operating layer between a company's people, data, and software.

// Nexora is initially targeting growing businesses that have outgrown manual processes but lack the resources or technical infrastructure required to build sophisticated automation internally. As our platform expands, we intend to move further upstream into larger organizations with increasingly complex operational requirements.
//         </p>
//       </div>
//               <div class="col-lg-7 text-center"
              
//                 >
//         {/* <p class="intro-lead fade-up " style={{marginTop:'26px', color:'white'}}>
//            "Nexora has demonstrated that AI can be more than a buzzword—it can become a meaningful part of how a business operates. Their platform has the potential to address a significant and growing need for companies looking to automate processes, improve productivity, and get more value from the technology they already have. We believe Nexora is building a platform with substantial long-term potential, and that’s why we’re excited to support the company as it enters its next stage of growth."
//         </p>
//                 <small class="text-center " style={{ color: 'white'}}><em >Michael Reynolds</em></small> */}
//                 <div className='text-center mt-4'>
//                   <img src={Intro}/>
//                 </div>
//         {/* <div class="intro-pillars fade-up">
//           <div class="pillar">
//             <div class="pillar-icon"><i class="fa fa-building-columns"></i></div>
//             <h5>Institutional Standards</h5>
//             <p>Every company undergoes rigorous due diligence aligned with our criteria.</p>
//           </div>
//           <div class="pillar">
//             <div class="pillar-icon"><i class="fa fa-shield-halved"></i></div>
//             <h5>Capital Preservation</h5>
//             <p>Senior debt structures and conservative LTV ratios protect downside in all market conditions.</p>
//           </div>
//           <div class="pillar">
//             <div class="pillar-icon"><i class="fa fa-chart-line"></i></div>
//             <h5>Value Creation</h5>
//             <p>Active asset management and strategic repositioning unlock latent value across every acquisition.</p>
//           </div>
//         </div>  */}
//         {/* <div class="text-center mt-3">
//         <img src="./assets/epa.png"/>
//         </div> */}
//       </div>
//             </div>
//             <hr></hr>

//            <div className="row gx-5 gy-4">

//   <div className="col-12 col-lg-4 d-flex">
//     <div className="introcards w-100">
//       <h5 style={{ paddingTop: '45px' }}>
//         AI-Powered Operations
//       </h5>

//       <div
//         style={{
//           width: '34px',
//           height: '2px',
//           backgroundColor: 'var(--gold)',
//           marginBottom: '16px'
//         }}
//       ></div>

//       <p>
//      Nexora is designed to help businesses apply AI where it can create measurable value—automating repetitive processes, connecting disconnected systems, and helping teams move from information to action more efficiently.
//       </p>
//     </div>
//   </div>


//   <div className="col-12 col-lg-4 d-flex">
//     <div className="introcards w-100">
//       <h5 style={{ paddingTop: '45px' }}>
//         Built to Expand
//       </h5>

//       <div
//         style={{
//           width: '34px',
//           height: '2px',
//           backgroundColor: 'var(--gold)',
//           marginBottom: '16px'
//         }}
//       ></div>

//       <p>
//        Customer relationships can begin with a single workflow or department and expand over time. As businesses connect additional systems, users, and AI-powered capabilities, Nexora has multiple opportunities to deepen platform adoption.
//       </p>
//     </div>
//   </div>


//   <div className="col-12 col-lg-4 d-flex">
//     <div className="introcards w-100">
//       <h5 style={{ paddingTop: '45px' }}>
//         The Operating Layer
//       </h5>

//       <div
//         style={{
//           width: '34px',
//           height: '2px',
//           backgroundColor: 'var(--gold)',
//                       marginBottom: '20px'
          
//         }}
//       ></div>

//       <p>
//        Nexora is designed to work alongside the software businesses already rely on. By connecting existing systems instead of requiring a complete technology replacement, the platform can help organizations introduce intelligent automation with less disruption.
//       </p>
//     </div>
//   </div>

// </div>
//   </div>
// </section>
//         </div>
//     )
// }

// export default intro

import React from 'react';

import Intro from '../assets/intro.jpg';

import './intro.css';
import { motion } from 'motion/react';

function IntroSection() {

  return (

    <motion.section id="intro" className="intro-section"
    initial={{
        opacity: 0,
        y: 50
      }}

      whileInView={{
        opacity: 1,
        y: 0
      }}

      transition={{
        duration: 0.8,
        ease: 'easeOut'
      }}

      viewport={{
        once: true,
        amount: 0.2
      }}
    >

      {/* Background decorative accents */}

      <div className="intro-glow intro-glow-left"></div>

      <div className="intro-glow intro-glow-right"></div>


      <div className="container position-relative">


        {/* SECTION HEADER */}

        <div className="intro-header">

          <div className="section-label intro-label">

            <span className="intro-label-line"></span>

            THE BOCH ADVANTAGE

          </div>


          <h2 className="section-title2 intro-title">

          Where Limited Supply
            <br className="d-none d-lg-block" />
            Meets Enduring Demand

          </h2>

        </div>


        {/* MAIN CONTENT */}

        <div className="row g-5 align-items-center intro-main">


          {/* TEXT */}

          <div className="col-12 col-lg-5">

            <div className="intro-text">

              <div className="intro-accent-line"></div>


              <p className="intro-body">

          Boch Investment Fund, LLC is focused on an asset class with a fundamental supply-and-demand dynamic: billboard inventory is limited and increasingly difficult to expand. In many states and municipalities, regulations restrict the construction of new billboard structures, creating a supply-constrained market where existing assets can become increasingly valuable. At the same time, private equity firms and publicly traded outdoor advertising companies continue to actively acquire billboard assets, increasing competition and demand for established locations. This combination of restricted supply and growing institutional interest creates an attractive environment for owners of strategically positioned billboard assets.

              </p>


              <p className="intro-body">

             Billboards also offer an appealing characteristic in an environment of rapid technological change. While artificial intelligence and other technologies continue to transform many industries and advertising channels, the underlying physical locations of billboards remain difficult to replicate or replace. Outdoor advertising provides businesses with highly visible exposure to consumers in physical locations where digital alternatives cannot provide the same presence. Boch Billboard Investment Fund, LLC is positioned to capitalize on these dynamics by investing in an established, supply-constrained asset class supported by ongoing advertising demand, limited new construction, and continued interest from larger industry participants.

              </p>


          


              {/* <p className="intro-body">

                Rather than asking businesses to replace the systems they
                already use, Nexora is designed to work alongside them.

              </p>


              <p className="intro-body">

                Our long-term vision is to become the intelligent operating
                layer between a company's people, data, and software.

              </p> */}


              {/* <p className="intro-body mb-0">

                Nexora is initially targeting growing businesses that have
                outgrown manual processes but lack the resources or technical
                infrastructure required to build sophisticated automation
                internally. As our platform expands, we intend to move further
                upstream into larger organizations with increasingly complex
                operational requirements.

              </p> */}

            </div>

          </div>


          {/* IMAGE */}

          <div className="col-12 col-lg-7">

            <div className="intro-image-wrapper">

              <div className="intro-image-accent"></div>

              <img
                src={Intro}
                alt="Nexora AI platform"
                className="intro-image"
              />

              <div className="intro-image-overlay"></div>


              <div className="intro-image-tag">

                <span className="intro-tag-line"></span>

                BILLBOARD OPERATORS

              </div>

            </div>

          </div>

        </div>


        {/* DIVIDER */}

        <div className="intro-divider"></div>


        {/* FEATURE CARDS */}

        <div className="row gx-5 gy-4">


          {/* CARD 1 */}

          <div className="col-12 col-lg-4 d-flex">

            <div className="introcards w-100">

              <div className="intro-card-number">
                01
              </div>


              <h5>

                Supply-Constrained Asset Class

              </h5>


              <div className="intro-card-line"></div>


              <p>

           Billboard inventory is inherently limited by regulations governing where and when new structures can be built. Restrictions on new construction in many states and municipalities make existing billboard locations particularly valuable, creating a market where established assets can benefit from limited competition and constrained future supply.

              </p>

            </div>

          </div>


          {/* CARD 2 */}

          <div className="col-12 col-lg-4 d-flex">

            <div className="introcards w-100">

              <div className="intro-card-number">
                02
              </div>


              <h5>

                Growing Institutional Demand

              </h5>


              <div className="intro-card-line"></div>


              <p>

             Billboard assets have attracted increasing interest from private equity firms and publicly traded outdoor advertising companies seeking to expand their portfolios. Continued acquisition activity creates additional demand for existing assets and reflects the broader institutional recognition of outdoor advertising as an established and durable investment category.

              </p>

            </div>

          </div>


          {/* CARD 3 */}

          <div className="col-12 col-lg-4 d-flex">

            <div className="introcards w-100">

              <div className="intro-card-number">
                03
              </div>


              <h5>

                Built to Endure Technological Change

              </h5>


              <div className="intro-card-line"></div>


              <p>

              Unlike many advertising and media businesses that face disruption from rapidly evolving technology, billboards are physical assets tied to specific, high-visibility locations. While the way advertisers reach consumers continues to evolve, the value of prominent outdoor locations remains difficult to replicate, providing an asset class that many view as relatively insulated from the direct effects of artificial intelligence and other technological changes.

              </p>

            </div>

          </div>


        </div>

      </div>

    </motion.section>

  );

}


export default IntroSection;